import React, { useContext, useState, useEffect } from 'react';
import { useDebounce } from 'hooks';
import styled from 'styled-components';
import { InputNew as Input, InputTextArea, Text } from 'components';
import FormContext from './FormContext';

// No additional validation required for printer code or front desk notes
const OtherSection = () => {
  const { userState, setUserState, setWorking } = useContext(FormContext);
  const [code, setCode] = useState(userState.frontEndInstructions?.copierCode);
  const [notes, setNotes] = useState(userState.frontEndInstructions?.notes);

  // Fields updates are debounced to improve performance so state validation doesn't occur on every character change
  const debouncedCode = useDebounce(code, 500);
  const debouncedNotes = useDebounce(notes, 500);

  const handleCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.currentTarget.value);
  };

  useEffect(() => {
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        copierCode: debouncedCode,
      },
    }));
  }, [debouncedCode, setUserState]);

  useEffect(() => {
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        notes: debouncedNotes,
      },
    }));
  }, [debouncedNotes, setUserState]);

  const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNotes(event.currentTarget.value);
  };

  return (
    <OtherSectionContainer>
      <Text>Copier/Printer Code</Text>
      <Input
        data-cy="front-desk-printer-code-input"
        placeholder="Code"
        value={code}
        onChange={handleCodeChange}
      />
      <Text>Front Desk Notes</Text>
      <InputTextArea
        data-cy="front-desk-notes-textarea"
        placeholder="Add notes"
        value={notes}
        onChange={handleNotesChange}
      />
    </OtherSectionContainer>
  );
};

export default OtherSection;

const OtherSectionContainer = styled.div`
  margin-top: 21px;
  > * {
    margin: 8px 0px;
  }
`;
